import React from 'react';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import { Magnetic as Mi } from "../../styles";
function SlideTransition(props) {
    return React.createElement(Slide, Object.assign({}, props, { direction: "down" }));
}
const commonToastWidth = '420px';
const iconSpacer = '0.5';
const fullWidth = '100%';
const miMediumIcon = {
    fontSize: Mi.uamIconMedium
};
const retryStyle = {
    border: '0',
    outline: 'none',
    backgroundColor: 'transparent',
    color: Mi.linkFontColor,
    cursor: Mi.linkBaseCursor,
    '&:hover': {
        color: Mi.linkFontColorHover
    }
};
// Emotions css cant be handled dynamically in props and it would create extra properties
const toastStyles = makeStyles((theme) => ({
    root: {
        borderRadius: Mi.baseBorderRadius,
        fontSize: Mi.uamIconMedium,
        width: fullWidth,
        minWidth: commonToastWidth,
        maxWidth: '90vw',
        [theme.breakpoints.down('sm')]: {
            minWidth: 'auto'
        },
        '& > * > div ': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        '& .MuiSnackbarContent-message': {
            display: 'flex',
            alignItems: 'center',
            flex: 1
        },
        '& .MuiSnackbarContent-action': {
            alignSelf: 'center',
            paddingLeft: 0
        }
    },
    intenseSuccess: {
        backgroundColor: Mi.uamAcknowledgeColor,
        color: Mi.colorWhite,
        border: `${Mi.baseBorderWidth} solid ${Mi.uamAcknowledgeColor}`
    },
    intenseWarning: {
        backgroundColor: Mi.uamAlertColor,
        color: Mi.colorWhite,
        border: `${Mi.baseBorderWidth} solid ${Mi.uamAlertColor}`
    },
    success: {
        backgroundColor: Mi.uamAcknowledgeBackgroundColor,
        color: Mi.uamAcknowledgeColor,
        border: `${Mi.baseBorderWidth} solid ${Mi.uamAcknowledgeColor}`
    },
    warning: {
        backgroundColor: Mi.uamAlertBackgroundColor,
        color: Mi.uamAlertColor,
        border: `${Mi.baseBorderWidth} solid ${Mi.uamAlertColor}`
    }
}));
export const Toaster = props => {
    const { message, type, isRetry, handleClose, open, delay, handleRetry, showCloseButton, translateFn, style } = props;
    const classes = toastStyles();
    const onHandleRetry = () => {
        handleRetry && handleRetry();
    };
    const onHandleClose = () => {
        handleClose(type);
    };
    const getToastClass = (type) => {
        if (type === "SuccessIntense" /* ToastType.SuccessIntense */)
            return 'intenseSuccess';
        else if (type === "Warning" /* ToastType.Warning */)
            return 'warning';
        else if (type === "WarningIntense" /* ToastType.WarningIntense */)
            return 'intenseWarning';
        else
            return 'success';
    };
    return (React.createElement(Snackbar, { id: "toasterSnackBar", anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
        }, disableWindowBlurListener: true, open: open, autoHideDuration: delay, onClose: onHandleClose, TransitionComponent: SlideTransition },
        React.createElement(SnackbarContent, { id: "toasterSnackBarContent", className: `${classes[getToastClass(type)]} ${classes.root} `, style: style, message: React.createElement("div", null,
                React.createElement(Box, { component: "span", style: miMediumIcon, className: `mi-icat-icon ${type === "Warning" /* ToastType.Warning */ || type === "WarningIntense" /* ToastType.WarningIntense */
                        ? 'mi-icon-alert-filled-triangle'
                        : 'mi-icon-complete-filled-circle'} `, m: iconSpacer }),
                React.createElement("span", { className: "mi-icon-uam" }),
                React.createElement(Box, { component: "span", className: "mi-spacer__h--narrow  mi-font-body-1", m: iconSpacer }, message)), action: isRetry ? (React.createElement("button", { style: retryStyle, id: "mi-toasterRetry", onClick: onHandleRetry, className: "mi-spacer__h--narrow mi-font-body-1" }, translateFn('Retry'))) : (showCloseButton && (React.createElement(IconButton, { id: "toasterClose", size: "small", "aria-label": "close", color: "inherit", onClick: onHandleClose },
                React.createElement(Box, { id: "mi-toast-cancel-button", className: `${type === "Warning" /* ToastType.Warning */ || type === "Success" /* ToastType.Success */
                        ? 'mi-icon-action-close'
                        : 'mi-icon-close'} mi-medium mi-font-body-1`, m: iconSpacer })))) })));
};
Toaster.defaultProps = {
    translateFn: (key) => key
};
//# sourceMappingURL=toast.component.js.map